import { connect } from 'react-redux';
import BaseForm from '../BaseForm/BaseForm';
import {
  updateVehicle,
  showError,
  clearErrors,
} from '../../redux/actions/vehicles';
import conditions from '../../data/conditions';
import insured from '../../data/insured';

class VehicleUpdateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: updateVehicle,
      name: 'Vehicle',
      action: 'Update',
      type: 'update',
      isTypeForm: false,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.registration)) {
      this.setState({ errors: ['registration'] });
      this.props.dispatch(showError('Please specify a registration'));
      return false;
    }
    if (isIndex(1) && isNaN(Number(data.vehicle_type_id))) {
      this.setState({ errors: ['vehicle_type_id'] });
      this.props.dispatch(showError('Please specify the vehicle type'));
      return false;
    }
    if (isIndex(2) && BaseForm.validator.isEmpty(data.manufacture_date)) {
      this.setState({ errors: ['manufacture_date'] });
      this.props.dispatch(showError('Please specify the manufacture date'));
      return false;
    }
    if (isIndex(3) && isNaN(Number(data.mileage))) {
      this.setState({ errors: ['mileage'] });
      this.props.dispatch(showError('Please specify the mileage'));
      return false;
    }
    if (isIndex(4) && isNaN(Number(data.service_mileage))) {
      this.setState({ errors: ['service_mileage'] });
      this.props.dispatch(showError('Please specify the service mileage'));
      return false;
    }
    if (isIndex(5) && BaseForm.validator.isEmpty(data.mot_date)) {
      this.setState({ errors: ['mot_date'] });
      this.props.dispatch(showError('Please specify the MOT date'));
      return false;
    }
    if (isIndex(6) && isNaN(Number(data.condition))) {
      this.setState({ errors: ['condition'] });
      this.props.dispatch(showError('Please specify the vehicle condition'));
      return false;
    }
    if (isIndex(7) && isNaN(Number(data.insured))) {
      this.setState({ errors: ['insured'] });
      this.props.dispatch(
        showError('Please specify whether the vehicle is insured or not'),
      );
      return false;
    }
    return data;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    const { mot_date, manufacture_date } = this.props.item;
    dispatch(
      actions.change('update.registration', this.props.item.registration) || '',
    );
    dispatch(
      actions.change(
        'update.vehicle_type_id',
        this.props.item.vehicle_type_id || 0,
      ),
    );
    dispatch(actions.change('update.mileage', this.props.item.mileage || 0));
    dispatch(
      actions.change(
        'update.service_mileage',
        this.props.item.service_mileage || 0,
      ),
    );
    dispatch(
      actions.change(
        'update.condition',
        !isNaN(Number(this.props.item.condition))
          ? this.props.item.condition
          : null,
      ),
    );
    dispatch(actions.change('update.insured', this.props.item.insured ? 1 : 0));
    dispatch(
      actions.change(
        'update.mot_date',
        mot_date ? mot_date.substring(0, 10) : '',
      ),
    );
    dispatch(
      actions.change(
        'update.manufacture_date',
        manufacture_date ? manufacture_date.substring(0, 10) : '',
      ),
    );
  }
}

const mapStateToProps = ({ vehicles, vehicleTypes }) => ({
  model: vehicles,
  fields: BaseForm.fields.vehicles.update,
  values: {
    insured,
    vehicle_type_id: vehicleTypes.vehicleTypes.map((type) => ({
      name: type.name,
      value: type.id,
    })),
    condition: conditions,
  },
});

export default connect(mapStateToProps)(VehicleUpdateForm);
